/**
 * Zastaví přehrávání všech aktivních GJVP videí na stránce včetně YouTube iframe videí
 */
export const pauseAllVideos = (): void => {
  // Zastavení vpPlayer videí
  if (window.vpPlayer && window.vpPlayer.players) {
    window.vpPlayer.players.forEach((player) => {
      if (player && player.pause) {
        player.pause();
      }
    });
  }

  // Pauza YouTube iframe videí, podmínka funkčnosti je aby se vložený iframe přidal s parametrem &enablejsapi=1 . Např:
  //   <iframe width="560" height="315" src="https://www.youtube.com/embed/oNiYSjbTAYg?si=zhUnDtipB2-b1Q8w&amp;enablejsapi=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
  const youtubeIframes = document.querySelectorAll('iframe[src*="youtube.com"]');
  youtubeIframes.forEach((iframe) => {
    try {
      const iframeElement = iframe as HTMLIFrameElement;
      // Pokud je iframe API načtené a video je přehráváno
      if (window.YT && iframeElement.contentWindow) {
        iframeElement.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
      }
    } catch (e) {
      console.warn('Nepodařilo se zastavit YouTube video:', e);
    }
  });
};
